import React, { useState } from 'react';
import { ChevronRight, Car, Compass, Construction, Building, Ticket, Sun, Home } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const BusinessVerticals = () => {
    const [activeSection, setActiveSection] = useState('hero');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            window.scrollTo({
                top: element.offsetTop - 80,
                behavior: 'smooth'
            });
            setActiveSection(sectionId);
            setMobileMenuOpen(false);
        }
    };

    // Animation variants
    const fadeInVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] }
        }
    };

    const scaleUpVariants = {
        hidden: { opacity: 0, scale: 0.95 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] }
        }
    };

    // Business verticals data with primary and secondary images
    const businessVerticals = [
        {
            id: 'topsteel',
            title: 'Dev Bhoomi Bar',
            description: 'Leading supplier of TMT bars since 2005, renowned for quality and trust.',
            icon: <Building size={20} className="text-white" />,
            url: 'https://devbhoomitmt.com/',
            primaryImage: "https://static.wixstatic.com/media/11062b_bb02f705f6b6495bae35d7f1580451aa~mv2.jpeg/v1/crop/x_504,y_0,w_2000,h_2000/fill/w_355,h_355,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Stacked%20Steel%20Rods.jpeg",
            secondaryImage: "https://img.freepik.com/free-photo/professional-industrial-welder-welding-metal-parts-metalworking-factory_342744-519.jpg?uid=R158437386&ga=GA1.1.516298163.1739876026&semt=ais_hybrid&w=740"
        },
        {
            id: 'skoda',
            title: 'Dev Bhoomi Skoda',
            description: 'Authorized Skoda dealer showcasing the best of German engineering.',
            icon: <Car size={20} className="text-white" />,
            url: 'https://dealers.skoda-auto.co.in/dev-bhoomi-skoda-showroom-and-service-dev-bhoomi-motors-pvt-ltd-car-dealer-gutkar-mandi-67723/Home?utm_source=locator&utm_medium=googleplaces',
            primaryImage: "https://ik.imagekit.io/zfayt6inj/WhatsApp%20Image%202025-04-28%20at%2018.49.17.jpeg",
            secondaryImage: "https://img.freepik.com/free-photo/blue-jeep-photo-shooting-sunset_114579-4043.jpg"
        },
        {
            id: 'hyundai',
            title: 'Dev Bhoomi Hyundai(Mandi)',
            description: 'Premium dealership offering a wide range of Hyundai vehicles.',
            icon: <Car size={20} className="text-white" />,
            url: 'https://devbhoomi.hyundaimotor.in',
            primaryImage: "https://ik.imagekit.io/zfayt6inj/pexels-introspectivedsgn-10012866.jpg?updatedAt=1747411860496",
            secondaryImage: "https://img.freepik.com/free-photo/where-i-need-sign-female-customer-modern-stylish-bearded-businessman-automobile-saloon_146671-16730.jpg"
        },
        {
            id: 'hyundai',
            title: 'Dev Bhoomi Hyundai(Shimla)',
            description: 'Premium dealership offering a wide range of Hyundai vehicles.',
            icon: <Car size={20} className="text-white" />,
            url: 'https://dev-bhoomi-shimla-hyundai.com',
            secondaryImage: "https://ik.imagekit.io/tdlebsr5e/pexels-lovetosmile-6694495.jpg?updatedAt=1747480001307",
            primaryImage: "https://img.freepik.com/free-photo/where-i-need-sign-female-customer-modern-stylish-bearded-businessman-automobile-saloon_146671-16730.jpg"
        },
        {
            id: 'real-estate-db',
            title: 'Dev Bhoomi Luxestate',
            description: 'Modern residential and commercial spaces across North India.',
            icon: <Home size={20} className="text-white" />,
            url: 'https://devbhoomiluxestate.com/',
            primaryImage: "https://img.freepik.com/free-photo/great-modern-infrastructure-megapolis_140725-8585.jpg",
            secondaryImage: "https://img.freepik.com/free-photo/mumbai-skyline-skyscrapers-construction_469504-21.jpg"
        },
        {
            id: 'gulmohar-grand',
            title: 'The Gulmohar Grand',
            description: 'Luxury hotel redefining hospitality in Una, Himachal Pradesh.',
            icon: <Compass size={20} className="text-white" />,
            url: 'https://thegulmohargrand.com',
            primaryImage: "https://ik.imagekit.io/jncw2kb8u/hotel-in-una1.jpg",
            secondaryImage: "https://gulmohargrandhotel.com/wp-content/uploads/2017/06/room1-750x460.jpg"
        },
        {
            id: 'grand-cinemaz',
            title: 'Grand Cinemaz',
            description: 'Premium cinema experience with modern auditoriums and comfortable seating.',
            icon: <Ticket size={20} className="text-white" />,
            url: 'https://grandcinemaz.com',
            primaryImage: "https://ik.imagekit.io/zfayt6inj/PHOTO-2025-06-17-20-50-28.jpg?updatedAt=1751034710812",
            secondaryImage: "https://img.freepik.com/free-photo/rows-red-seats-theater_53876-64710.jpg"
        },
        {
            id: 'solar-power',
            title: 'FDL Solar Power',
            description: 'Sustainable solar power projects driving clean energy adoption.',
            icon: <Sun size={20} className="text-white" />,
            url: 'https://fdlsolarpower.com/',
            primaryImage: "https://images.pexels.com/photos/356036/pexels-photo-356036.jpeg",
            secondaryImage: "https://images.pexels.com/photos/371917/pexels-photo-371917.jpeg"
        },
    ];



    return (
        <section className="py-20 bg-white dark:bg-gray-900">
            <div className="container mx-auto px-6">
                <motion.div
                    className="text-center mb-16"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={fadeInVariants}
                >
                    <span className="inline-block px-4 py-1 bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-100 rounded-full text-sm font-medium mb-4">
                        OUR BUSINESS
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 dark:text-white">Business Verticals</h2>
                    <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
                        Explore our diverse range of businesses across multiple industries, each committed to excellence and innovation.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {businessVerticals.map((business) => (
                        <motion.div
                            key={business.id}
                            className="group relative overflow-hidden rounded-2xl h-96 cursor-pointer"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, margin: "-100px" }}
                            variants={scaleUpVariants}
                            onClick={() => scrollToSection(business.id)}
                        >
                            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/50 to-black/80 z-10"></div>

                            {/* Image Container with perspective for 3D effect */}
                            <div className="absolute inset-0 transition-all duration-1000 preserve-3d"
                                style={{
                                    perspective: '1000px',
                                    transformStyle: 'preserve-3d',
                                    transform: 'rotateY(0deg)',
                                }}>

                                {/* Primary Image (front face) */}
                                <img
                                    src={business.primaryImage}
                                    alt={`${business.title} Division - Primary`}
                                    className="w-full h-full object-cover absolute inset-0 transition-all duration-1000 group-hover:opacity-0"
                                    style={{
                                        backfaceVisibility: 'hidden',
                                        transform: 'rotateY(0deg)',
                                        transformOrigin: 'center',
                                        transition: 'opacity 0.8s ease-in-out, transform 0.8s ease-in-out'
                                    }}
                                />

                                {/* Secondary Image (back face) */}
                                <img
                                    src={business.secondaryImage}
                                    alt={`${business.title} Division - Secondary`}
                                    className="w-full h-full object-cover absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-1000"
                                    style={{
                                        backfaceVisibility: 'hidden',
                                        transform: 'scale(1.1)',
                                        transformOrigin: 'center',
                                        transition: 'opacity 0.8s ease-in-out, transform 0.8s ease-in-out',
                                    }}
                                />
                            </div>

                            <div className="absolute bottom-0 left-0 right-0 p-6 z-20 transform transition-transform duration-500 group-hover:translate-y-2">
                                <div className="bg-amber-500 dark:bg-amber-500 w-10 h-10 rounded-full flex items-center justify-center mb-4 transition-all duration-500 group-hover:scale-110 group-hover:bg-amber-600">
                                    {business.icon}
                                </div>
                                <h3 className="text-2xl font-bold text-white mb-2 transition-all duration-300 group-hover:text-amber-200">{business.title}</h3>
                                <p className="text-gray-200 mb-4">
                                    {business.description}
                                </p>
                                <a
                                    href={business.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-amber-400 dark:text-amber-400 flex items-center text-sm font-medium transition-all duration-300 group-hover:text-white"
                                >
                                    Learn More <ChevronRight size={16} className="ml-1 transition-transform duration-300 group-hover:translate-x-1" />
                                </a>

                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BusinessVerticals;